import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import TruncatedText from 'UI/TruncatedText';

import styles from './styles.module.scss';

const SelectRealtorOption = ({
  firstName, lastName, email, onSelect, selected, isMe,
}) => (
  <article
    className={cn(
      styles.optionContainer,
      selected && styles.selected,
    )}
    aria-hidden="true"
    onClick={onSelect}
  >
    <span className={styles.fullName}>
      {firstName}
      {' '}
      {lastName}
      {' '}
      {isMe && '(me)'}
    </span>

    <TruncatedText variant="span" className={styles.email}>{email}</TruncatedText>

  </article>
);

SelectRealtorOption.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.func.isRequired,
  isMe: PropTypes.bool.isRequired,
};

SelectRealtorOption.defaultProps = {
  firstName: '',
  lastName: '',
  email: '',
};

export default SelectRealtorOption;
